import { Avatar } from "primereact/avatar";
import { Badge } from "primereact/badge";
import { classNames } from "primereact/utils";
import { useRef } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { PERMISSION_TRAINING_ATTANDANCES, PERMISSION_TRAINING_CLASSES, PERMISSION_TRAINING_CLASSROOMS, PERMISSION_TRAINING_CONTRACTS, PERMISSION_TRAINING_COURSES, PERMISSION_TRAINING_EVENTS, PERMISSION_TRAINING_LEVELS, PERMISSION_TRAINING_REGISTRATION, PERMISSION_TRAINING_SCHEDULE, PERMISSION_TRAINING_SESSIONS, PERMISSION_TRAINING_SLOTS, PERMISSION_TRAINING_SLOT_CHANGE_REQUESTS, PERMISSION_TRAINING_STUDENTS, PERMISSION_TRAINING_TEACHERS } from "../../../permissions";

export function TrainingsMenu({ onItemClick }) {
  const { hasPermission } = useAuthContext();
  const navigate = useNavigate();
  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;

  const toast = useRef(null);

  const hasClassroomsListPermission = hasPermission(PERMISSION_TRAINING_CLASSROOMS.LIST)
  const hasSlotsListPermission = hasPermission(PERMISSION_TRAINING_SLOTS.LIST)
  const hasLevelsListPermission = hasPermission(PERMISSION_TRAINING_LEVELS.LIST)
  const hasCoursesListPermission = hasPermission(PERMISSION_TRAINING_COURSES.LIST)
  const hasClassesListPermission = hasPermission(PERMISSION_TRAINING_CLASSES.LIST)
  const hasTeachersListPermission = hasPermission(PERMISSION_TRAINING_TEACHERS.LIST)
  const hasSchedulesListPermission = hasPermission(PERMISSION_TRAINING_SCHEDULE.LIST)
  const hasEventsListPermission = hasPermission(PERMISSION_TRAINING_EVENTS.LIST)
  const hasSessionsListPermission = hasPermission(PERMISSION_TRAINING_SESSIONS.LIST)

  const hasStudentsListPermission = hasPermission(PERMISSION_TRAINING_STUDENTS.LIST)
  const hasaAttandancesListPermission = hasPermission(PERMISSION_TRAINING_ATTANDANCES.LIST)

  const hasRegistrationsListPermission = hasPermission(PERMISSION_TRAINING_REGISTRATION.LIST)
  const hasContractsListPermission = hasPermission(PERMISSION_TRAINING_CONTRACTS.LIST)


  const itemRenderer = (item) => (
    <div className='p-menuitem-content'>
      <NavLink
        className={({ isActive, isPending }) =>
          'flex align-items-center p-menuitem-link ' + (isActive ? 'surface-100 text-900 border-right-2' : 'hover:surface-hover')
        }
        to={item.url}
        onClick={() => {
          // Close mobile menu when menu item is clicked
          if (onItemClick) {
            onItemClick();
          }
        }}>
        <span className={item.icon} />
        <span className="mx-2">{item.label}</span>
        {item.badge && <Badge className="ml-auto" value={item.badge} />}
        {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
      </NavLink>
    </div>
  );

  let items = [
    {
      label: "La formation",
      url: "/school/" + schoolId + "/admin/trainings/" + trainingId + "/info",
      icon: "pi pi-book",
      template: itemRenderer,

    },

    {
      label: 'Gestion de la formation',
      items: [
        {
          label: "Salles",
          url: "/school/" + schoolId + "/admin/trainings/" + trainingId + "/classrooms",
          icon: "pi pi-map",
          template: itemRenderer,
          disable: !hasClassroomsListPermission,
        },
        {
          label: "Créneaux",
          url: "/school/" + schoolId + "/admin/trainings/" + trainingId + "/slots",
          icon: "pi pi-bolt",
          template: itemRenderer,
          disable: !hasSlotsListPermission,
        },
        {
          label: "Niveaux",
          url: "/school/" + schoolId + "/admin/trainings/" + trainingId + "/levels",
          icon: "pi pi-sliders-v",
          template: itemRenderer,
          disable: !hasLevelsListPermission,
        },
        {
          label: "Matières",
          url: "/school/" + schoolId + "/admin/trainings/" + trainingId + "/courses",
          icon: "pi pi-file-edit",
          template: itemRenderer,
          disable: !hasCoursesListPermission,
        },
        {
          label: "Classes",
          url: "/school/" + schoolId + "/admin/trainings/" + trainingId + "/classes",
          icon: "pi pi-th-large",
          template: itemRenderer,
          disable: !hasClassesListPermission,
        },
        {
          label: "Enseignant(e)s",
          url: "/school/" + schoolId + "/admin/trainings/" + trainingId + "/teachers",
          icon: "pi pi-user-edit",
          template: itemRenderer,
          disable: !hasTeachersListPermission,
        },
        {
          label: "Programme de la semaine",
          icon: "pi pi-clock",
          url: "/school/" + schoolId + "/admin/trainings/" + trainingId + "/schedule",
          template: itemRenderer,
          disable: !hasSchedulesListPermission,
        },
        {
          label: "Agenda",
          icon: "pi pi-calendar-plus",
          url: "/school/" + schoolId + "/admin/trainings/" + trainingId + "/events",
          template: itemRenderer,
          disable: !hasEventsListPermission,
        },
        {
          label: "Séances de cours",
          icon: "pi pi-briefcase",
          url: "/school/" + schoolId + "/admin/trainings/" + trainingId + "/sessions",
          template: itemRenderer,
          disable: !hasSessionsListPermission,
        },
        {
          label: "Import",
          icon: "pi pi-upload",
          url: "/school/" + schoolId + "/admin/trainings/" + trainingId + "/import",
          template: itemRenderer,
        }
      ]
    }, {
      label: 'Vie Scolaire',
      items: [
        {
          label: "Elèves",
          url: "/school/" + schoolId + "/admin/trainings/" + trainingId + "/students",
          icon: "pi pi-users",
          template: itemRenderer,
          disable: !hasStudentsListPermission,
        },
        {
          label: "Feuilles de présence",
          url: "/school/" + schoolId + "/admin/trainings/" + trainingId + "/attendances",
          icon: "pi pi-check",
          template: itemRenderer,
          disable: !hasaAttandancesListPermission,
        },
        {
          label: "Documents",
          url: "/school/" + schoolId + "/admin/trainings/" + trainingId + "/documents",
          icon: "pi pi-folder-open",
          template: itemRenderer,
        },
        {
          label: "Calendrier",
          icon: "pi pi-calendar",
          url: "/school/" + schoolId + "/admin/trainings/" + trainingId + "/planning",
          template: itemRenderer,
        },
      ]
    }, {
      label: 'Inscriptions',
      items: [
        {
          label: "Inscriptions",
          url: "/school/" + schoolId + "/admin/registrations/" + trainingId + "/candidates",
          icon: "pi pi-envelope",
          template: itemRenderer,
        },
      ]
    },
  ];

  return (
    <div style={{ 
      height: '100%', 
      overflowY: 'auto', 
      overflowX: 'hidden',
      WebkitOverflowScrolling: 'touch'
    }}>
      <div className="w-full">
        {items.map((item, index) => {
          if (item.separator) {
            return <hr key={index} className="my-3 border-surface-200" />;
          }
          
          if (item.items) {
            return (
              <div key={index} className="mb-3">
                <div className="text-600 font-semibold text-sm mb-2 mt-2 px-3">
                  {item.label}
                </div>
                {item.items.map((subItem, subIndex) => (
                  <NavLink
                    key={subIndex}
                    to={subItem.url}
                    className={({ isActive }) =>
                      `flex align-items-center p-2  mb-1 border-round text-700 no-underline hover:surface-100 transition-colors transition-duration-150 ${
                        isActive ? 'surface-100 text-900 border-left-3 border-primary' : ''
                      }`
                    }
                    onClick={() => {
                      if (onItemClick) {
                        onItemClick();
                      }
                    }}
                  >
                    <i className={`${subItem.icon} mr-3`}></i>
                    <span className="flex-1">{subItem.label}</span>
                    {subItem.badge && <Badge className="ml-2" value={subItem.badge} />}
                    {subItem.shortcut && (
                      <span className="ml-2 border-1 surface-border border-round surface-100 text-xs p-1">
                        {subItem.shortcut}
                      </span>
                    )}
                  </NavLink>
                ))}
              </div>
            );
          }
          
          return (
            <NavLink
              key={index}
              to={item.url}
              className={({ isActive }) =>
                `flex align-items-center p-2  mb-1 border-round text-700 no-underline hover:surface-100 transition-colors transition-duration-150 ${
                  isActive ? 'surface-100 text-900 border-left-3 border-primary' : ''
                }`
              }
              onClick={() => {
                if (onItemClick) {
                  onItemClick();
                }
              }}
            >
              <i className={`${item.icon} mr-3`}></i>
              <span className="flex-1">{item.label}</span>
              {item.badge && <Badge className="ml-2" value={item.badge} />}
              {item.shortcut && (
                <span className="ml-2 border-1 surface-border border-round surface-100 text-xs p-1">
                  {item.shortcut}
                </span>
              )}
            </NavLink>
          );
        })}
      </div>
    </div>
  )
}